import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ServiceFetcher from '../../shared/libs/ServiceFetcher';
import { TryCatchGeneric, checkServerError } from '../../shared/utils';
import * as appLoaderActions from '../store/slices/appLoader'
import { ROUTES } from '../router'

const usePostCalculate = (body) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [statusService, setStatusService] = useState({ data: undefined, error: undefined });

  const options = {
    method: 'POST',
    body,
  };

  const fetchCalculate = async () => {
    setIsLoading(true);
    await TryCatchGeneric(
      () => ServiceFetcher('/calculate', options),
      setStatusService,
      setIsLoading,
      () => { }
    );
  };

  const { data, error } = statusService;

  useEffect(() => {
    dispatch(isLoading ? appLoaderActions.showAppLoader() : appLoaderActions.hideAppLoader());
  }, [isLoading]);

  useEffect(() => {
    if (error && checkServerError(error)) history.push(ROUTES.ERROR)
  }, [error]);

  return {
    calculation: data,
    isLoading,
    isError: error,
    fetchCalculate,
  };
};

export default usePostCalculate;
